import { Theme } from "@material-ui/core";

export const placeholderImage = (theme: Theme) => ({
	width: "100px",
});
